import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

/**
 * Error Boundary global. Captura errores de render en el árbol de componentes
 * y muestra un fallback recuperable en lugar de dejar la pantalla en blanco.
 * Los errores de boundaries deben implementarse con componentes de clase.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Punto único para enviar a un servicio de logging (Sentry, etc.).
        console.error('ErrorBoundary capturó un error:', error, errorInfo);
    }

    handleReload = () => {
        this.setState({ hasError: false });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        gap: 2,
                        p: 3,
                        textAlign: 'center',
                        backgroundColor: '#f5f5f5',
                    }}
                >
                    <ReportProblemOutlinedIcon sx={{ fontSize: 56, color: '#f43f5e' }} />
                    <Typography variant="h5" fontWeight="bold" color="textPrimary">
                        Algo salió mal
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ maxWidth: 420 }}>
                        Ocurrió un error inesperado al mostrar esta pantalla. Puedes recargar
                        para volver a intentarlo.
                    </Typography>
                    <Button variant="contained" onClick={this.handleReload} sx={{ mt: 1 }}>
                        Recargar
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
